import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Displays a legal disclaimer below AI-generated readings.
 * Use on Horoscope, Tarot, Kundali, Compatibility, and all AI output pages.
 */
export default function ReadingDisclaimer() {
  return (
    <div className="reading-disclaimer" style={{
      marginTop: '1.5rem', padding: '1rem 1.2rem', borderRadius: '8px',
      background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
      fontSize: '0.78rem', color: '#999', lineHeight: 1.7
    }}>
      <p style={{ margin: 0 }}>
        🤖 <strong>AI-Generated Content</strong> · For entertainment &amp; informational purposes only ·
        Not professional advice
      </p>
      <p style={{ margin: '0.5rem 0 0' }}>
        This reading is generated by artificial intelligence. It does not constitute medical, financial,
        legal, or psychological advice. Never delay seeking professional help based on this content.
        See our <Link to="/terms-and-conditions" style={{ color: '#f9a825' }}>Terms &amp; Conditions</Link> and{' '}
        <Link to="/privacy-policy" style={{ color: '#f9a825' }}>Privacy Policy</Link>.
      </p>
    </div>
  );
}
